import {
  ADMIN_CHAT,
  Div,
  Dropdown,
  HeaderIconWrapper,
  Overlay,
  Separator,
  TextButton,
  ThreeDots,
  isAdmin,
  overlayAnimationVariant,
} from '@vgrubs/components';
import { vDriveDeliveryStatus } from 'components/src/types/api/wallet.types';
import {
  VDriveDeliveryEntity,
  VDriveSource,
} from 'components/src/types/deliveries.types';
import { VDriveProvider } from 'components/src/types/shared.types';
import { Dispatch, SetStateAction, useState } from 'react';

export const DeliveriesDropdown = ({
  data,
  setRefundModal,
  handleGetCancelVDriveDeliveryFee,
  handleClaimDelivery,
  handleHistoryAssign,
  handleMarkAsReady,
}: {
  data: VDriveDeliveryEntity | null;
  setRefundModal: Dispatch<SetStateAction<boolean>>;
  handleGetCancelVDriveDeliveryFee: () => void;
  handleClaimDelivery: () => void;
  handleHistoryAssign: () => void;
  handleMarkAsReady: () => void;
}) => {
  const [dropdown, setDropdown] = useState(false);
  const [historyAssignModal, setHistoryAssignModal] = useState(false);

  /* The customer's chat on this delivery, in the admin's Dispatcher tab - a
     new tab, like the tracker link beside it. */
  const openChat = () => {
    if (!data?.conversationId) return;
    setDropdown(false);
    window.open(
      `${ADMIN_CHAT}?scope=dispatcher&conversation=${data.conversationId}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  const openTrackingLink = () => {
    if (!data) return;
    if (!data.trackingLink) return;
    setDropdown(false);
    window.open(data.trackingLink, '_blank', 'noopener,noreferrer');
  };

  const handleRefund = () => {
    setDropdown(false);
    setRefundModal(true);
  };

  // Our own fleet never supports Mark as Ready and refuses to cancel once
  // the food is in the car.
  const isVDriveFleet =
    data?.vDriveSource === VDriveSource.vdriveFleet ||
    data?.provider === VDriveProvider.vdriveFleet;

  const isCancelDisabled =
    data?.status === vDriveDeliveryStatus.completed ||
    data?.status === vDriveDeliveryStatus.cancelled ||
    data?.status === vDriveDeliveryStatus.returned ||
    (isVDriveFleet &&
      (data?.status === vDriveDeliveryStatus.picked_up ||
        data?.status === vDriveDeliveryStatus.en_route_dropoff));

  // TODO CHECK IF STATUS CAN BE FAILED
  // ||
  // data?.status === 'failed';

  const handleCancel = () => {
    if (isCancelDisabled) return;
    setDropdown(false);
    handleGetCancelVDriveDeliveryFee();
  };

  const handleClaimDeliveryClick = () => {
    setDropdown(false);
    handleClaimDelivery();
  };

  const handleHistoryAssignClick = () => {
    setDropdown(false);
    handleHistoryAssign();
  };

  const handleMarkAsReadyClick = () => {
    setDropdown(false);
    handleMarkAsReady();
  };

  const isAssignDisabled = data?.dispatcher;
  const canMarkAsReady = data?.canMarkAsReady;
  const markAsReadySent = data?.markAsReadySent;

  return (
    <>
      <Dropdown
        padding="16px 20px"
        isOpen={dropdown}
        toLeft
        triggerComponent={
          <HeaderIconWrapper
            $opened={dropdown}
            onClick={() => setDropdown((prev) => !prev)}
          >
            <ThreeDots />
          </HeaderIconWrapper>
        }
      >
        <Div $width="200px" $flex $column $alignStart $gap="8px" $gapSM="8px">
          {isAdmin && (
            <>
              <TextButton
                onClick={handleClaimDeliveryClick}
                disabled={isAssignDisabled}
              >
                Dispatcher: Claim
              </TextButton>
              <Separator $m="0" />
            </>
          )}
          {isAdmin && !isVDriveFleet && (
            <>
              <TextButton
                onClick={handleMarkAsReadyClick}
                disabled={!canMarkAsReady}
              >
                Mark as Ready{' '}
                {markAsReadySent ? 'Sent' : !canMarkAsReady && 'Unavailable'}
              </TextButton>
              <Separator $m="0" />
            </>
          )}

          <TextButton onClick={handleCancel} disabled={isCancelDisabled}>
            Cancel Delivery
          </TextButton>
          <Separator $m="0" />
          <TextButton onClick={handleRefund}>Request A Refund</TextButton>
          <Separator $m="0" />
          <TextButton onClick={openTrackingLink}>Tracker Link</TextButton>
          {isAdmin && data?.conversationId && (
            <>
              <Separator $m="0" />
              <TextButton onClick={openChat}>Open chat</TextButton>
            </>
          )}
          {isAdmin && (
            <>
              <Separator $m="0" />
              <TextButton onClick={handleHistoryAssignClick}>
                Fleet Assign History
              </TextButton>{' '}
            </>
          )}
        </Div>
      </Dropdown>
      {dropdown && (
        <Overlay
          key="modalOverlay"
          variants={overlayAnimationVariant}
          initial="initial"
          animate="animate"
          exit="exit"
          onClick={() => setDropdown(false)}
        />
      )}
    </>
  );
};
